// START Open Requre.JS wrapper
define([
	'jquery',
	'pubsub',
	'shared.main.screen',
	'shared.lazyload',
	'foundation.util.keyboard'
	], function($,pubsub,screenSize,lazyload) {
// END Open Require.JS wrapper


/****
* Shows/hides navigation by clicking the menu button
* visible on small devices.
***/

	var DEBUG = false;
	var PLUGIN_IDENTIFIER = "menuButton";
	var menuButton;
	var topNavOverFlowHide = WCS_CONFIG.get('topnav::overflowHide') || false;
	var enableMobileTopNavForTablet = WCS_CONFIG.get('topnav::enableMobileTopNavForTablet') || false;
	var isTabletDevice = (window.devicePixelRatio >= 2 && (window.innerWidth >= 640 && window.innerWidth <= 1024)) && enableMobileTopNavForTablet;
	
	(function(){
		menuButton = {
			defaults: {
				el: ".topnav-menubutton",
				dataAttr: "menu-button-options",
				menuButton: ".topnav-menubutton a",
				menuIcon: ".topnav-menubutton-icon",
				menuText: ".topnav-menubutton-text",
				topnav: ".topnav",
				topnavHeader: ".topnav-header",
				topnavHeaderScreen: ".topnav-header-screen",
				accordion: ".topnav-accordion",
				searchButton: ".topnav-searchbutton",
				searchContainer: ".topnav-search-container",
				accordionSearchClass: "topnav-accordion-search",
				searchMenuClass: "topnav-menu-search",
				speed: 250,
				easing: 'swing',
				lazyLoadImages: 'picture.lazy-load'
			},

			/**
			 * Initialize Main Menu Button Functions
			 **/
			init : function() {
				if ( DEBUG ) console.log('initilizing ' + PLUGIN_IDENTIFIER);

				var self = this; // Make plugin namespace available throughout
				self.deferred = $.Deferred();

				self.$element = $(self.defaults.el);
				self.$body = $('body');
				self.$html = $('html');
				self.metadata = self.$element.data(self.defaults.dataAttr);
				self.config = $.extend( {}, self.defaults, self.metadata );
				
				self.$accordion = $(self.config.accordion);
				self.accordionMenuWidth = self.$accordion.data('mobile-menu-width');
				self.$menuButton = $(self.config.menuButton);
				self.$menuButtonAriaOpen = $(self.$menuButton).attr('aria-label');
				self.$menuButtonAriaClose = $(self.$menuButton).data('closeAriaLabel');
				self.$menuIcon = $(self.config.menuIcon);
				self.$menuText = $(self.config.menuText);
				self.$topnav = $(self.config.topnav);
				self.$topnavHeader = $(self.config.topnavHeader);
				self.$topnavHeaderScreen = $(self.config.topnavHeaderScreen);
				self.$searchButton = $(self.config.searchButton);
				self.$searchContainer = $(self.config.searchContainer);

				self.enableSearch = self.$accordion.hasClass(self.config.accordionSearchClass);
				self.enablePeekABooFeature = self.$accordion.closest('header').hasClass('peek-a-boo-menu');
				self.$accordion.removeClass('collapse');

				this.events();

				self.configureAriaTags();

				self.deferred.resolve();
				
				return self;
			},

			/**
			 * Initilize specific plugins
			 **/
			events : function() {
				var self = this;

				self.$menuButton.on('click touch', function(e) {
					e.preventDefault();

					// when the menu is opened, lazy load images within menu that are not hidden on small screens
					var $media = $(self.config.topnavHeader).find('.media').not('.hide-for-small-only');
					$media.find(self.config.lazyLoadImages).lazyload();

					self.toggleMobileNav(self.$accordion);

					// Disable scroll on the page content when menu is open
					// Apply the custom widths on the accordion content when the menu is open
					if(self.enablePeekABooFeature) {
						self.$body.toggleClass('peek-a-boo-enabled');
						if(topNavOverFlowHide) {
							self.$html.toggleClass('peek-a-boo-enabled');
						}
						self.$accordion.css({
							width: self.accordionMenuWidth + '%'
						});
					}

					if($(window).scrollTop() !== 0) {
						window.scrollTo(0, 0);
					}
				});

				// Close small screen menu if visitor clicks on the overlay-screen oiutside the menu
				self.$topnavHeaderScreen.on('click touch', function(e) {
					e.preventDefault();
					self.$body.css({
						overflow: ''
					});
					self.hideNavigation();
				});

				// Close small screen menu if visitor resizes out of the breakpoint
				$.pubsub('subscribe','window.resize.breakpoint',function(event,data) {
					if(data.now !== 'small') {
						self.hideNavigation();
					}

					self.configureAriaTags();

					// Reset the scroll on page-content & the accordion widths 
					if(self.enablePeekABooFeature) {
						self.$body.removeClass('peek-a-boo-enabled');
						if(topNavOverFlowHide) {
							self.$html.removeClass('peek-a-boo-enabled');
						}

						self.$accordion.css({
							width: ''
						});
					}
				});

				// Close small screen menu if visitor opens the search box
				$.pubsub('subscribe','vfdp.aem.topnav.search.open',function(event,data) {
					self.hideNavigation();
				});
			},

			// configure the aria-labelledby attribute for proper accessibility controls
			// since the navigation is only hidden on small screens
			configureAriaTags : function() {
				var self = this;

				if(screenSize.size() !== "small") {
					self.$accordion.removeAttr('aria-labelledby');
				}
				else {
					self.$accordion.attr({'aria-labelledby':'topnav-menu-button'});
				}
			},

			toggleMobileNav : function(el) {
				var self = this;

				if (screenSize.size() === "small" || isTabletDevice) {
					if(el[0].offsetHeight != 0)
					{
						self.hideNavigation();
					} else {
						self.showNavigation();
					}
				} else {
					self.showNavigation();
				}
			},

			hideNavigation: function() {
				var self = this;

				// Remove the focus trap listener so the user can tab to next elements
				if(self.lastFocusableMenuItem && self.lastFocusableMenuItem.length)
					self.lastFocusableMenuItem.off('focusout.from.last.menu.item');

				if(!self.$accordion.hasClass('scrolled')) {
					if ((screenSize.size() === "small" || isTabletDevice) && self.$topnav.hasClass('active')) {

						self.$accordion.animate({'height': 0}, {
							duration: self.config.speed,
							easing: self.config.easing,
							complete: function() {
								self.$accordion.css({'display': 'none'});
								self.$topnav.removeClass('active');
								self.$accordion.css({
									'height': '',
									'display': ''
								});
								self.$accordion.removeClass('active');

								if(self.enableSearch) {
									self.hideSearchContainer();
								}

								//close any open accordion items
								$.pubsub('publish','vfdp.aem.topnav.accordion.close');
							}
						});

					} else if (screenSize.size() !== "small" && !isTabletDevice) {

						self.$topnav.removeClass('active');
						self.$accordion.css({
							'height': '',
							'display': ''
						}).removeClass('active');

						if(self.enableSearch) {
							self.hideSearchContainer();
						}

						//close any open accordion items
						$.pubsub('publish','vfdp.aem.topnav.accordion.close');
					}

					self.$menuIcon.removeClass('icon-close').addClass('icon-menu');
					self.$menuButton.attr({'aria-expanded':'false'});
					self.$menuButton.attr({'aria-label':self.$menuButtonAriaOpen});
					$('.topnav-utility-small-container').removeClass('hide');

					// toggle the menu button text if enabled
					if(self.$menuText.length) {
						self.$menuText.text(self.config.textClosed);
					}

					// unbind scroll events
					$(document).off('scroll', self.mobileNavigationScrollEvents);
				}
			},

			showNavigation: function() {
				var self = this,
				accordionHeight;
				$.pubsub('publish','vfdp.aem.topnav.accordion.open');

				self.$topnav.addClass('active');

				if(self.enableSearch) {
					self.showSearchContainer();
				}

				accordionHeight = self.$accordion.outerHeight();

				self.$accordion.css({'height': 0});
				self.$accordion.animate({'height': accordionHeight}, {
					duration: self.config.speed,
					easing: self.config.easing,
					complete: function() {
						self.$accordion.height('');
					}
				});

				self.$menuIcon.removeClass('icon-menu').addClass('icon-close');
				self.$menuButton.attr({'aria-expanded':'true'});
				self.$menuButton.attr({'aria-label':self.$menuButtonAriaClose});

				// toggle the menu button text if enabled
				if(self.$menuText.length) {
					self.$menuText.text(self.config.textOpened);
				}

				// Get the current list of focusable elements in the menu
				// This only works once the menu items are visible
				var focusable = Foundation.Keyboard.findFocusable(self.$accordion);
				// Set the last item as an insatnce property so we can access it later
				self.lastFocusableMenuItem = focusable.last();
				// Add the focus trap listener to the focusout event
				self.lastFocusableMenuItem.on('focusout.from.last.menu.item', function(){
					// Jump the focus to the close/menu button
					self.$menuButton.focus();
				});

				$(document).on('scroll', self, self.mobileNavigationScrollEvents);

			},

			showSearchContainer: function() {
				var self = this;
				self.$searchContainer.addClass('active ' + self.config.searchMenuClass);
			},


			hideSearchContainer: function() {
				var self = this;

				self.$searchContainer.removeClass(self.config.searchMenuClass);

				// don't hide the search container if the small header search has been clicked
				if(!self.$searchButton.hasClass('active')) {
					self.$searchContainer.removeClass('active');
				}
			},

			// scroll events
			mobileNavigationScrollEvents: function(event) {
				var self = event.data;

				// when scrolling past the end of the accordion nav, update small header to display as if menu is closed
				if($(window).scrollTop() > (self.$accordion.offset().top + self.$accordion.height())) {
					if(self.$menuIcon.hasClass('icon-close')) {
						self.$accordion.addClass('scrolled');
						self.$menuIcon.removeClass('icon-close').addClass('icon-menu');
					}
					if(self.enableSearch) {
						self.$searchContainer.removeClass('active');
					}
					if(self.$menuText.length) {
						self.$menuText.text(self.config.textClosed);
					}
				}

				// when scrolling the accordion nav back into view, reset small header to display menu as opened
				else {
					if(self.$topnav.hasClass('active')){
						self.$accordion.removeClass('scrolled');
						self.$menuIcon.removeClass('icon-menu').addClass('icon-close');
					}
					if(self.enableSearch) {
						self.$searchContainer.addClass('active');
					}
					if(self.$menuText.length) {
						self.$menuText.text(self.config.textOpened);
					}
				}
			}
		};

		return menuButton.init();

	})();

	return menuButton;
});
